import { Box, Button, Typography, useTheme } from '@mui/material';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { tokens } from '../theme';
import { canAccessPage, getAdminUser, isCustomRole } from '../utils/permissions';

// Pages a custom role lands on (in this order) when it can't open the dashboard.
const LANDING_PAGES = [
  '/countries',
  '/excursions',
  '/country-excursion',
  '/booking',
  '/feedback',
  '/allpassengers',
  '/guide',
  '/package',
  '/promotion',
  '/userfeedback',
  '/message',
  '/notifications',
  '/reports/excursion',
  '/reports/excursion-attendance',
  '/reports/excursion-summary',
  '/reports/destinations',
  '/trip-reports',
  '/reports/guide-performance',
  '/reports-by-user',
  '/reports/survey-results',
  '/reports/survey-responses',
];

/** Blocks admin panel pages the signed-in custom role has no permission for. */
const PermissionGuard = ({ children }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { pathname } = useLocation();
  const user = getAdminUser();

  if (!isCustomRole(user) || canAccessPage(pathname, user)) return children;

  if (pathname === '/') {
    const landing = LANDING_PAGES.find((p) => canAccessPage(p, user));
    if (landing) return <Navigate to={landing} replace />;
  }

  return (
    <Box m="20px" display="flex" flexDirection="column" alignItems="flex-start" gap="12px">
      <Typography variant="h3" fontWeight="bold" color={colors.grey[100]}>
        Access denied
      </Typography>
      <Typography color={colors.grey[300]}>
        Your role doesn&apos;t have permission to open this page. Please contact the Super Admin if you need access.
      </Typography>
      <Link to="/">
        <Button
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.grey[100],
            fontWeight: 'bold',
            '&:hover': { backgroundColor: colors.blueAccent[800] },
          }}
        >
          Go to home
        </Button>
      </Link>
    </Box>
  );
};

export default PermissionGuard;
